import { render, staticRenderFns } from "./PayrollCloneForm.vue?vue&type=template&id=32ca5666&"
import script from "./PayrollCloneForm.vue?vue&type=script&lang=js&"
export * from "./PayrollCloneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports